;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:offsoo-landing":true});}catch(e){}}();import clsx from 'clsx'
import React, { forwardRef } from 'react'

export function CheckboxField({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
  return (
    <div
      data-slot="field"
      {...props}
      className={clsx(
        className,
        'grid grid-cols-[1.125rem_1fr] gap-x-4 gap-y-1 sm:grid-cols-[1rem_1fr]',
        '*:data-[slot=control]:col-start-1 *:data-[slot=control]:row-start-1 *:data-[slot=control]:mt-0.75 sm:*:data-[slot=control]:mt-1',
        '*:data-[slot=label]:col-start-2 *:data-[slot=label]:row-start-1',
        '*:data-[slot=description]:col-start-2 *:data-[slot=description]:row-start-2',
        'has-data-[slot=description]:**:data-[slot=label]:font-medium',
      )}
    />
  )
}

const base = [
  'relative isolate flex size-4.5 items-center justify-center rounded-[0.3125rem] sm:size-4',
  'before:absolute before:inset-0 before:-z-10 before:rounded-[calc(0.3125rem-1px)] before:bg-white before:shadow-sm',
  'peer-checked:before:bg-(--checkbox-checked-bg)',
  'dark:before:hidden',
  'dark:bg-white/5 dark:peer-checked:bg-(--checkbox-checked-bg)',
  'border border-mist-950/15 peer-checked:border-transparent peer-hover:peer-checked:border-transparent peer-hover:border-mist-950/30 peer-checked:bg-(--checkbox-checked-border)',
  'dark:border-white/15 dark:peer-checked:border-white/5 dark:peer-hover:peer-checked:border-white/5 dark:peer-hover:border-white/30',
  'after:absolute after:inset-0 after:rounded-[calc(0.3125rem-1px)] after:shadow-[inset_0_1px_--theme(--color-white/15%)]',
  'dark:after:-inset-px dark:after:hidden dark:after:rounded-[0.3125rem] dark:peer-checked:after:block',
  'peer-focus-visible:outline-2 peer-focus-visible:outline-offset-2 peer-focus-visible:outline-mist-950/50 dark:peer-focus-visible:outline-white/60',
  'peer-disabled:opacity-50',
  'peer-disabled:border-mist-950/25 peer-disabled:bg-mist-950/5 peer-disabled:[--checkbox-check:var(--color-mist-950)]/50 peer-disabled:before:bg-transparent',
  'dark:peer-disabled:border-white/20 dark:peer-disabled:bg-white/2.5 dark:peer-disabled:[--checkbox-check:var(--color-white)]/50 dark:peer-checked:peer-disabled:after:hidden',
  'forced-colors:[--checkbox-check:HighlightText] forced-colors:[--checkbox-checked-bg:Highlight] forced-colors:peer-disabled:[--checkbox-check:Highlight]',
  'dark:forced-colors:[--checkbox-check:HighlightText] dark:forced-colors:[--checkbox-checked-bg:Highlight] dark:forced-colors:peer-disabled:[--checkbox-check:Highlight]',
]

const checkedColor = [
  '[--checkbox-check:var(--color-white)] [--checkbox-checked-bg:var(--color-mist-950)] [--checkbox-checked-border:var(--color-mist-950)]/90',
  'dark:[--checkbox-checked-bg:var(--color-mist-300)] dark:[--checkbox-check:var(--color-mist-950)]',
]

type CheckboxProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'color'> & {
  className?: string
}

export const Checkbox = forwardRef(function Checkbox(
  { className, ...props }: CheckboxProps,
  ref: React.ForwardedRef<HTMLInputElement>,
) {
  return (
    <span data-slot="control" className={clsx('relative inline-flex', className)}>
      <input
        ref={ref}
        type="checkbox"
        {...props}
        className="peer absolute inset-0 z-10 m-0 cursor-pointer opacity-0 disabled:cursor-not-allowed"
      />
      <span className={clsx(base, checkedColor, '[&>svg]:opacity-0 peer-checked:[&>svg]:opacity-100')}>
        <svg
          className="size-4 stroke-(--checkbox-check) transition-opacity sm:h-3.5 sm:w-3.5"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
    </span>
  )
})
